
// Responds to TRIGGER_EDAP_EVENT action
function triggerEdapEvent(store, action = {payload: {eventName: '', eventData: {}, options: {}}}) {
    /* istanbul ignore next */
    if (typeof window === 'undefined') {
        return;
    }


    const {payload} = action;

    window.edap.push((edapInstance) => {
        edapInstance.trigger(payload.eventName, payload.eventData, payload.options);
    });
}

// responds to TRIGGER_EDAP_PAGEVIEW action
function triggerEdapPageView(store, action = {payload: {publicUuid: '-1', pagename: ''}}) {
    const {payload} = action;
    let publicuuid = `${payload.publicUuid}`;

    if (!publicuuid) {
        publicuuid = '-1';
    }

    window.analyticsdatalayer.publicuuid = publicuuid;
    window.analyticsdatalayer.pagename = `IPM-SelfServiceOnboarding:${payload.pagename}`;
    window.analyticsdatalayer.pageurl = document.location.pathname + document.location.search + document.location.hash;
    window.edap.push((edapInstance) => {
        edapInstance.trigger('pageview');
    });
}


export {triggerEdapPageView, triggerEdapEvent};
